<template>
  <div class="oneBox">
    <div :class="['insertBox', !isNext ? 'next' : 'noNext']">
      <div class="close" @click="closeTestBox">
        <img src="../assets/close.png" />
      </div>
      <div class="isNext" v-show="!isNext">
        <div class="step">
          <el-steps :active="active" align-center>
            <el-step v-for="item in list" :key="item.id" :title="item.text" :icon="item.icon" :status='item.status' ref="step"></el-step>
          </el-steps>
        </div>
        <div class="activeBox" v-show="active === 0">
          <div class="table">
            <div class="line1">
              <div class="line1Item" v-for="item in tabTitleList" :key="item.id">{{item.title}}</div>
            </div>
            <div class="flexBox">
              <div class="line">
                <div v-for="item in browser" :key="item.id">
                  <div :class="[item.id === 3 ? 'center' : null]">
                    <i :class="item.icon && item.icon"></i>
                    <span :style="{'color': item.color}">{{ item.text }}</span>
                  </div>
                </div>
              </div>
              <div class="line">
                <div v-for="item in system" :key="item.id">
                  <div :class="[item.id === 3 ? 'center' : null]">
                    <i :class="item.icon && item.icon"></i>
                    <span :style="{'color': item.color}">{{ item.text }}</span>
                  </div>
                </div>
              </div>
              <div class="line">
                <div v-for="item in status" :key="item.id">
                  <div :class="[item.id === 3 ? 'center' : null]">
                    <i :class="item.icon && item.icon"></i>
                    <span :style="{'color': item.color}">{{ item.text }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="error" v-show="!isOnline">
            <span>异常检测，学生可能无法使用学习系统正常上课</span>
          </div>
          <div class="nextBtn">
            <div @click="next">下一步</div>
          </div>
        </div>
        <div class="headset" v-show="active === 1">
          <audio
            ref="audio"
            :src="music"
            style="display: none; position: absolute; left: -9999px; top: 0;"
          ></audio>
          <div class="headset-line"></div>
          <div class="listenThis">
            <div class="show" @click="play">播放</div>
            <span>点击播放，您能听见音乐吗？</span>
          </div>
          <div class="headset-bigBox">
            <div class="bigBox-left">
              <div class="headset-left-inner-1">
                <img :src="headsetImg" class="headset-img" />
                <el-slider v-model="value" @input="sliderChange"></el-slider>
              </div>
              <div class="headset-left-inner-2">
                <div class="noListen">如果听不到，请切换设备再试试。</div>
                <div class="chooseEqu" v-show="false">
                  <span>请选择设备</span>
                  <div class="chooseBox">
                    <span>默认-Headphones</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="bigBox-right">
              <div @click="canListen">A. 能听见音乐</div>
              <div @click="twonot">B. 不能听见音乐</div>
            </div>
          </div>
        </div>
        <div class="mic" v-show="active === 2">
          <div class="mic-line"></div>
          <div class="mic-title">对着麦克风说话，您能看见麦克风音量条跳动？</div>
          <div class="mic-bigBox">
            <div class="mic-left">
              <img :src="micImg" class="micImg" />
              <div class="micBlock">
                <div
                  v-for="item in micBlock"
                  :key="item.id"
                  :class="['block', item.isShow ? 'block-active' : null]"
                ></div>
              </div>
            </div>
            <div class="mic-right">
              <div @click="thrCan">A. 能看见跳动</div>
              <div @click="thrnot">B. 不能看见跳动</div>
            </div>
          </div>
        </div>
      </div>
      <div class="endBox" v-show="isNext">
        <div class="title">检测结果</div>
        <div class="isOk">{{lastTitle}}</div>
        <div class="endBox-center">
          <div v-for="item in list" :key="item.id">
            <i :class="item.isOk ? 'el-icon-success' : 'el-icon-warning'"></i>
            <span>{{item.text}}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
let analyser;
export default {
  data() {
    return {
      rightImg: require("../assets/img/right.png"),
      headsetImg: require("../assets/img/headset.png"),
      micImg: require("../assets/img/mic.png"),
      value: 50,
      active: 0,
      browser: [
        {
          id: 1,
          text: "浏览器"
        },
        {
          id: 2,
          text: ""
        },
        {
          id: 3,
          text: "正常",
          icon: "el-icon-success",
          color: "#0DBC00"
        }
      ],
      system: [
        {
          id: 1,
          text: "操作系统"
        },
        {
          id: 2,
          text: ""
        },
        {
          id: 3,
          text: "正常",
          icon: "el-icon-success",
          color: "#0DBC00"
        }
      ],
      status: [
        {
          id: 1,
          text: "网络状态"
        },
        {
          id: 2,
          text: "连接成功"
        },
        {
          id: 3,
          text: "网络较慢",
          icon: "el-icon-warning",
          color: "#FFC128"
        }
      ],
      micBlock: [
        {
          id: 1,
          isShow: false
        },
        {
          id: 2,
          isShow: false
        },
        {
          id: 3,
          isShow: false
        },
        {
          id: 4,
          isShow: false
        },
        {
          id: 5,
          isShow: false
        },
        {
          id: 6,
          isShow: false
        },
        {
          id: 7,
          isShow: false
        },
        {
          id: 8,
          isShow: false
        },
        {
          id: 9,
          isShow: false
        },
        {
          id: 10,
          isShow: false
        }
      ],
      tabTitleList: [
        {
          id: 1,
          title: "检测项"
        },
        {
          id: 2,
          title: "检测结果"
        },
        {
          id: 3,
          title: "状态"
        }
      ],
      isNext: false,
      list: [
        {
          id: 1,
          text: "基本检测",
          isOk: null,
          icon: "el-icon-setting",
          status: ''
        },
        {
          id: 2,
          text: "耳机/扬声器",
          isOk: null,
          icon: "el-icon-headset",
          status: ''
        },
        {
          id: 3,
          text: "麦克风",
          isOk: null,
          icon: "el-icon-microphone",
          status: ''
        }
      ],
      isOnline: null,
      music: require("../assets/baga.mp3"),
      lastTitle: "",
      forSure: []
    };
  },
  methods: {
    closeTestBox() {
      this.isNext = false;
      this.active = 0;
      this.list.forEach(item => {
        item.status = '';
      })
      if(!this.$refs.audio.paused) { // 3.5+ 关闭弹窗音乐停止* * *
        this.$refs.audio.pause();
      }
      this.$emit("closeTestInner", false);
    },
    next() {
      this.active = 1;
      this.list[0].isOk = true;
      this.list[0].status = 'success';
    },
    canListen() {
      this.$refs.audio.pause();
      this.active = 2;
      this.list[1].isOk = true;
      this.list[1].status = 'success';
      let audioContext = new (window.AudioContext ||
        window.webkitAudioContext)();
      let mediaStreamSource = null;
      let scriptProcessor = null;
      if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
        navigator.mediaDevices.getUserMedia({ audio: true }).then(stream => {
          mediaStreamSource = audioContext.createMediaStreamSource(stream);
          scriptProcessor = audioContext.createScriptProcessor(4096, 1, 1);
          mediaStreamSource.connect(scriptProcessor);
          scriptProcessor.connect(audioContext.destination);
          scriptProcessor.onaudioprocess = e => {
            let buffer = e.inputBuffer.getChannelData(0);
            let maxVal = Math.max.apply(Math, buffer);
            let just = Math.min(Math.max(parseInt(maxVal * 100), 0), 10);
            this.micBlock.forEach((item, index) => {
              if (just >= index) {
                item.isShow = true;
              } else {
                item.isShow = false;
              }
            });
          };
        });
      } else {
        this.$message({
          message: "不支持获取媒体接口",
          type: "error"
        });
      }
    },
    thrCan() {
      this.active = 3;
      this.list[2].isOk = true;
      this.list[2].status = 'success';
      this.isNext = true;
      if (this.list.every(item => item.isOk)) {
        this.lastTitle = "一切正常哦";
      } else {
        this.lastTitle = "设备检测未通过，可能会影响上课体验哦";
      }
    },
    myBrowser() {
      var userAgent = navigator.userAgent; //取得浏览器的userAgent字符串
      var isOpera = userAgent.indexOf("Opera") > -1;
      if (isOpera) {
        return "Opera";
      } //判断是否Opera浏览器
      if (userAgent.indexOf("Firefox") > -1) {
        return "FF";
      } //判断是否Firefox浏览器
      if (userAgent.indexOf("Chrome") > -1) {
        return "Chrome";
      }
      if (userAgent.indexOf("Safari") > -1) {
        return "Safari";
      } //判断是否Safari浏览器
      if (
        userAgent.indexOf("compatible") > -1 &&
        userAgent.indexOf("MSIE") > -1 &&
        !isOpera
      ) {
        return "IE";
      } //判断是否IE浏览器
    },
    detectOS() {
      var sUserAgent = navigator.userAgent;

      var isWin =
        navigator.platform == "Win32" || navigator.platform == "Windows";
      var isMac =
        navigator.platform == "Mac68K" ||
        navigator.platform == "MacPPC" ||
        navigator.platform == "Macintosh" ||
        navigator.platform == "MacIntel";
      if (isMac) return "Mac";
      var isUnix = navigator.platform == "X11" && !isWin && !isMac;
      if (isUnix) return "Unix";
      var isLinux = String(navigator.platform).indexOf("Linux") > -1;

      var bIsAndroid = sUserAgent.toLowerCase().match(/android/i) == "android";
      if (isLinux) {
        if (bIsAndroid) return "Android";
        else return "Linux";
      }
      if (isWin) {
        return "Windows";
      }
      return "other";
    },
    play() {
      const audio = this.$refs.audio;
      audio.play();
    },
    sliderChange(val) {
      this.$refs.audio.volume = val / 100;
    },
    twonot() {
      this.$refs.audio.pause();
      this.list[1].isOk = false;
      this.list[1].status = 'error';
      this.active = 2;
      let audioContext = new (window.AudioContext ||
        window.webkitAudioContext)();
      let mediaStreamSource = null;
      let scriptProcessor = null;
      if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
        navigator.mediaDevices.getUserMedia({ audio: true }).then(stream => {
          mediaStreamSource = audioContext.createMediaStreamSource(stream);
          scriptProcessor = audioContext.createScriptProcessor(4096, 1, 1);
          mediaStreamSource.connect(scriptProcessor);
          scriptProcessor.connect(audioContext.destination);
          scriptProcessor.onaudioprocess = e => {
            let buffer = e.inputBuffer.getChannelData(0);
            let maxVal = Math.max.apply(Math, buffer);
            let just = Math.min(Math.max(parseInt(maxVal * 100), 0), 10);
            this.micBlock.forEach((item, index) => {
              if (just >= index) {
                item.isShow = true;
              } else {
                item.isShow = false;
              }
            });
          };
        });
      } else {
        this.$message({
          message: "不支持获取媒体接口",
          type: "error"
        });
      }
    },
    thrnot() {
      this.list[2].isOk = false;
      this.list[2].status = 'error';
      this.active = 3;
      this.isNext = true;
      if (this.list.every(item => item.isOk)) {
        this.lastTitle = "一切正常哦";
      } else {
        this.lastTitle = "设备检测未通过，可能会影响上课体验哦";
      }
    }
  },
  mounted() {
    this.browser[1].text = this.myBrowser();
    this.system[1].text = this.detectOS();
    if (navigator.onLine) {
      this.isOnline = true;
      this.status[2].text = "网络正常";
      this.status[2].color = "#0dbc00";
      this.status[2].icon = "el-icon-success";
    } else {
      this.isOnline = false;
      this.status[1].text = "连接异常";
    }
  }
};
</script>

<style lang="scss" scoped>
@mixin wh($w: 100%, $h: 100%) {
  width: $w;
  height: $h;
}
@mixin flexCenter() {
  display: flex;
  align-items: center;
  justify-content: center;
}
@mixin flexColumn() {
  display: flex;
  flex-direction: column;
}
@mixin marginAuto() {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
}
.oneBox {
  @include wh(100%, 100%);
  background: rgba(#000000, 0.75);
  position: absolute;
  .insertBox {
    @include marginAuto();
    @include wh(791px, 527px);
    @include flexColumn();
    border-radius: 30px;
    background-color: #fff;
    padding: 20px;
    box-sizing: border-box;
    .activeBox,
    .headset,
    .mic {
      @include wh(751px, 400px);
      @include flexColumn();
      align-items: center;
    }
    .close {
      @include wh(62px, 62px);
      position: absolute;
      cursor: pointer;
      transition: all 0.5s ease;
      right: -34px;
      top: -31px;
      &:hover {
        transform: scale(1.2);
      }
      img {
        @include wh();
      }
    }
    .step {
      @include wh(100%, 50px);
    }
    .table {
      @include wh(90%, 240px);
      @include flexColumn();
      margin-top: 30px;
      color: #fff;
      font-size: 17px;
      .line1 {
        display: flex;
        height: 40px;
        background: #ff8f00;
        border-radius: 13px 13px 0 0;
        display: flex;
        font-weight: 500;
        padding: 0 24px;
        box-sizing: border-box;
        .line1Item {
          padding-left: 1.5px;
          &:nth-child(3) {
            text-align: center;
          }
        }
        div {
          flex: 1;
          line-height: 40px;
        }
      }
      .flexBox {
        @include flexColumn();
        flex: 1;
        background: #fffcee;
        color: #5a5a5a;
        padding: 0 20px;
        box-sizing: border-box;
        div {
          flex: 1;
          display: flex;
          div {
            flex: 1;
            position: relative;
            i {
              height: 100%;
              margin-right: 7px;
            }
          }
        }
        .line {
          display: flex;
          align-items: center;
          justify-content: space-around;
        }
        .lineTitle {
          width: 340px;
          position: absolute;
          bottom: -22px;
          left: 0;
          font-size: 13px;
          color: #ff8f00;
        }
      }
    }
    .error {
      @include wh(100%, 60px);
      @include flexCenter();
      span {
        color: #f33434;
        font-weight: 400;
        font-size: 14px;
      }
    }
    .nextBtn {
      @include wh(100%, 50px);
      @include flexCenter();
      margin: 20px 0;
      div {
        @include wh(145px, 47px);
        background: rgba(255, 143, 0, 1);
        border-radius: 24px;
        text-align: center;
        line-height: 47px;
        color: #fff;
        cursor: pointer;
        transition: all 0.5s ease;
        &:hover {
          background: #f06c14;
        }
      }
    }

    .headset-line,
    .mic-line {
      margin-top: 30px;
      @include wh(90%, 0px);
      border-top: 1px dashed #ffc843;
      box-sizing: border-box;
    }
    .listenThis {
      @include wh(90%, 50px);
      margin: 20px 0;
      display: flex;
      align-items: center;
      line-height: 50px;
      .show {
        @include wh(94px, 47px);
        background: #ffcb49;
        border-radius: 24px;
        color: #fff;
        text-align: center;
        line-height: 47px;
        font-size: 20px;
        cursor: pointer;
        transition: all 0.5s ease;
        &:hover {
          background: #f33434;
        }
      }
      span {
        margin-left: 15px;
        font-size: 17px;
        font-weight: 500;
        color: rgba(90, 90, 90, 1);
        font-family: PingFangSC-Medium, PingFang SC;
      }
    }
    .headset-bigBox {
      @include wh(90%, 210px);
      display: flex;
      .bigBox-left,
      .bigBox-right {
        flex: 1;
        display: flex;
        flex-direction: column;
      }
      .bigBox-right {
        @include flexColumn();
        @include flexCenter();
        background-color: #fffcee;
        & > div:nth-child(1) {
          background-color: #ff8f00;
          color: #fff;
        }
        & > div:nth-child(2) {
          background-color: #fffcee;
          border: 1px solid rgba(255, 143, 0, 1);
          color: #5a5a5a;
          margin-top: 25px;
        }
        div {
          @include wh(277px, 58px);
          border-radius: 29px;
          text-align: center;
          line-height: 58px;
          cursor: pointer;
        }
      }
      .headset-left-inner-1,
      .headset-left-inner-2 {
        flex: 1;
      }
      .headset-left-inner-1 {
        padding-right: 25px;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        .headset-img {
          @include wh(46px, 38px);
          margin-right: 14px;
        }
        /deep/ .el-slider {
          flex: 1;
        }
        /deep/ .el-slider__bar {
          background-color: #ffcb49;
        }
        /deep/ .el-slider__button {
          border: 2px solid #ffcb49;
        }
      }
      .headset-left-inner-2 {
        @include flexColumn();
        justify-content: center;
        .noListen {
          color: #838383;
          font-size: 14px;
        }
        .chooseEqu {
          display: flex;
          align-items: center;
          margin-top: 30px;
          span {
            font-size: 17px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: rgba(90, 90, 90, 1);
          }
          .chooseBox {
            @include wh(196px, 38px);
            @include flexCenter();
            background-color: #fffcee;
            border-radius: 19px;
            margin-left: 12px;
            span {
              font-size: 17px;
              font-family: PingFangSC-Medium, PingFang SC;
              font-weight: 500;
              color: rgba(90, 90, 90, 1);
              line-height: 24px;
            }
          }
        }
      }
    }
    .mic-title {
      @include wh(90%, 60px);
      display: flex;
      align-items: center;
      padding: 0 20px;
      box-sizing: border-box;
      font-size: 17px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 600;
      color: rgba(90, 90, 90, 1);
      line-height: 24px;
    }
    .mic-bigBox {
      display: flex;
      @include wh(90%, 210px);
      .mic-left,
      .mic-right {
        flex: 1;
      }
      .mic-left {
        @include flexCenter();
        .micImg {
          @include wh(40px, 58px);
        }
      }
      .mic-right {
        @include flexColumn();
        @include flexCenter();
        background-color: #fffcee;
        & > div:nth-child(1) {
          background-color: #ff8f00;
          color: #fff;
        }
        & > div:nth-child(2) {
          background-color: #fffcee;
          border: 1px solid rgba(255, 143, 0, 1);
          color: #5a5a5a;
          margin-top: 25px;
        }
        div {
          @include wh(277px, 58px);
          border-radius: 29px;
          text-align: center;
          line-height: 58px;
          cursor: pointer;
        }
      }
      .micBlock {
        display: flex;
        margin-left: 28px;
        .block {
          @include wh(16px, 62px);
          background-color: #e5e5e5;
          margin-right: 8px;
        }
        .block-active {
          background-color: #ffcb49;
        }
      }
    }
  }
}
.endBox {
  @include wh();
  @include flexColumn();
  align-items: center;
  .title {
    @include wh(100%, 60px);
    color: #ff8f00;
    font-size: 33px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    text-align: center;
    line-height: 60px;
  }
  .isOk {
    @include wh(100%, 40px);
    line-height: 40px;
    text-align: center;
    color: #f33434;
    font-size: 18px;
    margin-top: 15px;
  }
  .endBox-center {
    @include flexColumn();
    align-items: center;
    justify-content: center;
    width: 277px;
    height: 178px;
    background: rgba(255, 252, 238, 1);
    border-radius: 11px;
    margin-top: 30px;
    div {
      width: 100%;
      flex: 1;
      display: flex;
      align-items: center;
      padding: 0 30px;
      box-sizing: border-box;
    }
    i {
      @include wh(21px, 21px);
      @include flexCenter();
      margin-right: 15px;
      font-size: 21px;
    }
    span {
      font-size: 20px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(72, 72, 72, 1);
    }
  }
}
/deep/ .el-icon-warning {
  color: #ffc128;
}
/deep/ .el-icon-success {
  color: #0dbc00;
}
.colorGreen {
  color: #0dbc00;
}
.colorYellow {
  color: #ffc128;
}
.center {
  height: 100%;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  padding-left: 84px;
}
.next {
  background-image: url("../assets/bottom.png");
  background-position: left bottom;
  background-size: cover;
}
.noNext {
  background-image: url("../assets/teacher_public.png");
  background-position: left bottom;
  background-size: cover;
}
</style>